import React from 'react';
function Cirle({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <circle cx="12" cy="12" r="3.35" />
    </svg>
  );
}

export default Cirle;
